import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
import TableOfContents from "../TableOfContents/TableOfContents.tsx";
import TocMobile from "../ToCTelephone/TocTelephone.tsx";
import TextBox from "./TextBox";
import ReferencesSafety from "./ReferencesSafety";
import "./Safety.css";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";
const Safety = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  const headingsData = [
    {
      level: 2,
      text: "Working on a safe environment",
      id: "safe-environment",
    },

    {
      level: 3,
      text: "Working with cadmium",
      id: "working-with-cadmium",
    },
    {
      level: 2,
      text: "Avoiding GMO propagation",
        id: "Avoiding GMO propagation",
      },
      {
          level: 3,
          text: "Auxotrophy",
          id: "Auxotrophy",
      },
      {
          level: 3,
          text: "Mucus-binding management",
          id: "Mucus-binding management",
      },

    {
      level: 2,
      text: "HGT - Dut/Ung",
      id: "designs",
    },
    {
      level: 3,
      text: "LBP for the upcoming years ",
      id: "lbt",
    },
    {
      level: 3,
      text: "Present dangers with bacteria",
      id: "resistance",
    },
    {
      level: 3,
      text: "Uplasmid : a promising tool for LBP",
      id: "uplasmid",
    },
    {
      level: 3,
      text: "Uplasmid : benefits and testing",
      id: "benefits",
    },
    {
      level: 2,
      text: "References",
      id: "references",
    },
  ];
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
        {loading ? ( // Conditionally render spinner or content based on loading state
          <div className="spinner-container fixed h-screen w-screen bg-white z-10">
            <RingLoader color="#BA55D3" loading={loading} />{" "}
            <script>{document.body.style.overflow = 'hidden'}</script>
            {/* Use BarLoader from react-spinners */}
          </div>
        ) : <script>{document.body.style.overflow = 'auto'}</script>}
          <>
            {/* Set the size and crop the image on top of the page */}
            <div className="top-page">
              <h1>Safety</h1>
            </div>
            {/* divide the section in columns */}
            <div
              className="grid grid-cols-12 gap-4"
              style={{ marginRight: "50px", marginLeft: "50px" }}
            >
              {/* section on the left (=Table of content) */}
              <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
                {/* it will stay visible on the viewport */}
                <div className="sticky top-4 scrollable">
                  {/* call the Table of contents with headingData modified above */}
                  <TableOfContents headings={headingsData} />
                </div>
              </div>
              {/* main content which is a separated file you call and it is displayed on the right of the section above */}
              <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
                <TextBox />

                <ReferencesSafety />
              </main>
              {/* display the table of content when the viewport is too small */}
              <div className="md:hidden col-span-12 order-3 z-[8] TOCstyle">
                <TocMobile headings={headingsData} />
              </div>
            </div>
          </>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Safety, "safety");
